<div class="p-gutter container">
  <div class="card p-3 ">
    <h4 class="text-center">{{ mode === 'review' ? 'Review SAQ Examination' : 'Mark SAQ Examination' }} for
      {{examination.examinationName}}</h4>
    <hr>

    <div class="row">
      <div *ngIf="mode === 'mark'" class="d-flex align-items-center justify-content-between flex-wrap gap-2 py-2">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div>
            <small class="text-muted fw-bold">No. of candidates assigned: {{candidatesQuestionsData?.length ?? 0}} | </small>
            <small class="text-muted fw-bold">Marked: {{totalMarkedCandidates}} | </small>
            <small class="text-muted fw-bold">Unmarked: {{totalUnMarkedCandidates}}</small>
          </div>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" id="pendingFilterMark" [ngModel]="showPendingOnly"
                   [ngModelOptions]="{ standalone: true }" (ngModelChange)="showPendingOnly = $event; onPendingFilterChange()">
            <label class="form-check-label small fw-bold text-muted" for="pendingFilterMark">Pending only</label>
          </div>
        </div>
        <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1" (click)="requestMoreScripts()"
                [disabled]="loadingMoreScripts">
          <mat-icon svgIcon="mat:add_circle_outline" style="font-size: 16px; width: 16px; height: 16px;"></mat-icon>
          {{
          loadingMoreScripts
          ? 'Requesting...'
          : (candidatesQuestionsData.length === 0 ? 'Request Scripts' : 'Request More Scripts')
          }}
        </button>
      </div>
      <div *ngIf="mode === 'review'" class="d-flex align-items-center justify-content-between flex-wrap gap-2 py-2">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div>
            <small class="text-muted fw-bold">Total: {{candidateCount ?? 0}} | </small>
            <small class="text-muted fw-bold">Unmarked: {{candidateUnmarkedCount}} | </small>
            <small class="text-muted fw-bold">Ready: {{candidateMarkedCount}} | </small>
            <small class="text-muted fw-bold">Assigned: {{candidatesQuestionsData?.length}} | </small>
            <small class="text-muted fw-bold">Reviewed: {{totalCandidatesReviewed}} | </small>
            <small class="text-muted fw-bold">Pending: {{totalCandidatesPending}}</small>
          </div>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" id="pendingFilterReview" [ngModel]="showPendingOnly"
                   [ngModelOptions]="{ standalone: true }" (ngModelChange)="showPendingOnly = $event; onPendingFilterChange()">
            <label class="form-check-label small fw-bold text-muted" for="pendingFilterReview">Pending only</label>
          </div>
        </div>
      
      <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1" (click)="requestMoreScripts()"
          [disabled]="loadingMoreScripts">
          <mat-icon svgIcon="mat:add_circle_outline" style="font-size: 16px;"></mat-icon>
          {{
          loadingMoreScripts
          ? 'Requesting...'
          : (candidatesQuestionsData.length === 0 ? 'Request Scripts' : 'Request More Scripts')
          }}
        </button>
        </div>
      <div class="col-md-3 candidatesdiv" style="max-height: 80vh; overflow-y: auto;">
        <div *ngFor="let cand of filteredCandidates">
          <div class="justify-content-between">
            <button class="p-3 btn  mb-1 canlist" [id]="cand.examNo"
              [ngClass]="cand.marked?  cand.reviewed? 'btn-reviewed':'btn-marked' 
              :'btn-unmarked'"
              (click)="loadCandidateQuestions(cand)">{{cand.examNo}}
              <div class="d-inline ml-1" *ngIf="cand.marked">
                <button>
                  <span *ngIf="cand.marked && !cand.reviewed">Marked </span>
                  <span *ngIf="cand.reviewed && cand.marked ">Reviewed </span>
                  <span class=""><mat-icon class="mat-icon-button icon-sm " svgIcon="mat:check_circle" title="Marked"
                      style="font-size: x-small;"></mat-icon></span>

                </button>
                <small *ngIf="mode=='review' && cand.examiner && cand.marked" class="d-block">Marked By: {{cand.examiner}}</small>
                <small *ngIf="cand.reviewer && cand.reviewed" class="d-block">Reviewed By: {{cand.reviewer}}</small>

              </div>
            </button>
          </div>

        </div>
      </div>
      <div class="col-md-9" style="max-height: 80vh; overflow-y: auto;" #origin>
        <div class="p-gutter" *ngIf="selectedCandidateQuestion">
          <div *ngIf="mode != 'review' && selectedCandidateQuestion?.marked" class="alert alert-warning mt-1">
            <b class="text-muted">
              This script has already been graded and is no longer eligible for re-evaluation.
            </b>
          </div>
          <div class="headerdiv" id="scrollToTop">
            <h4>Candidate Number: {{selectedCandidateQuestion.examNo}}</h4>
            <h5>Examination Name: {{examination.examinationName}}</h5>
            <h6> Duration: {{examination.duration}} mins Examination Status: {{selectedCandidateQuestion.examStatus}}
            </h6>
            <hr>
          </div>
          <div class="card p-3 mb-2"
            *ngFor="let question of selectedCandidateQuestion.essayQuestionModels; let i = index">
            <h5>Question {{i+1}}</h5>
            <h5 class="" [innerHTML]="question.question"></h5>
            <div class="form-control border-box" [innerHTML]="question.candidateAnswer"></div>
            <div class="mt-3">
              <p class="text-muted">Possible Answers: {{question.possibleAnswers}}</p>
            </div>
            
            <div *ngIf="examination.enableAIMarking && question.aiMarked && mode === 'review'" class="mt-2 p-2 rounded border"
                 [ngClass]="question.aiIsCorrect ? 'border-success bg-light' : 'border-warning bg-light'">
              <div class="d-flex align-items-center gap-2">
                <span class="badge" [ngClass]="question.aiIsCorrect ? 'bg-success' : 'bg-warning text-dark'">
                  <mat-icon svgIcon="mat:smart_toy"
                            style="font-size:14px; width:14px; height:14px; vertical-align:middle;"></mat-icon>
                  AI Verdict: {{ question.aiIsCorrect ? 'Correct' : 'Incorrect' }}
                </span>
              </div>
              <p class="mb-0 mt-1 small text-muted" *ngIf="question.aiReason">
                <strong>AI Reason:</strong> {{ question.aiReason }}
              </p>
            </div>
<div class="d-flex mt-3">
  <label class="form-label mr-2 mt-2">Marked:</label>
              <ng-select class="form-select mr-2" [(ngModel)]="question.answerStatusString"
                [ngModelOptions]="{ standalone: true }" disabled="true">
                <ng-option value="NotMarked">Not Marked</ng-option>
                <ng-option value="Correct">Correct</ng-option>
                <ng-option value="Incorrect">Incorrect</ng-option>
              </ng-select>

              <ng-container *ngIf="mode !== 'review'">
                <button class="btn btn-success mr-2" (click)="markCorrect(question,i,selectedCandidateQuestion.examNo)"
                  [disabled]="question.answerStatusString=='Correct'" [disabled]="selectedCandidateQuestion.marked">Mark
                  Correct</button>
                <button class="btn btn-warning" (click)="markIncorrect(question,i,selectedCandidateQuestion.examNo)"
                  [disabled]="question.answerStatusString=='Incorrect'"
                  [disabled]="selectedCandidateQuestion.marked">Mark Incorrect</button>
              </ng-container>

              <button *ngIf="mode === 'review'" class="btn btn-primary ml-auto"
                (click)="openAdjustScoreModal(question,i,selectedCandidateQuestion.examNo)">Adjust Score</button>
            </div>
          </div>
          <div class="mt-3">
            <h5>Total Score: {{calculateTotalScore(selectedCandidateQuestion)}}</h5>
          </div>
          <div class="d-flex justify-content-center mt-3">

            <div class="mb-3 mr-0 col-lg-7">
              <button class="form-control bg-success text-white" type="button" (click)="markCandidate(origin)"
                *ngIf="mode !== 'review' && !selectedCandidateQuestion?.marked">
                Submit Assessment
              </button>

              <button class="form-control bg-success text-white" type="button" (click)="markCandidate(origin)"
                *ngIf="mode === 'review' && !selectedCandidateQuestion?.reviewed">
                Submit Review
              </button>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">

            <button class="btn btn-primary" (click)="previousCandidate()" [disabled]="!hasPreviousCandidate()">Previous
              Candidate</button>
            <button class="btn btn-primary" (click)="nextCandidate()" [disabled]="!hasNextCandidate()">Next
              Candidate</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
